import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, StringField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class NeuralAmpModelBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new NeuralAmpModelBox({
            uuid,
            graph,
            name: "NeuralAmpModelBox",
            pointerRules: {
                accepts: [Pointers.NeuralAmpModel],
                mandatory: true,
                exclusive: false,
            },
            resource: "preserved",
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "NeuralAmpModelBox";
    static Resource = "preserved";
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitNeuralAmpModelBox, this);
    }
    get tags() {
        return NeuralAmpModelBox.Tags;
    }
    get label() {
        return this.getField(1);
    }
    get model() {
        return this.getField(2);
    }
    initializeFields() {
        return {
            1: StringField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "model",
                deprecated: false,
                pointerRules: NoPointers,
            }),
        };
    }
}
